import React, { useEffect, useState, useRef, useCallback, useMemo, Fragment } from 'react'
import Slider from 'react-slick'
import DynamicPopup from 'components/popUps/DynamicPopup'
import { useActivity } from 'contexts/activity-context'
import useMainClass from 'hooks/use-main-cass'
import DotsIndicator from './components/DotsIndicator'
import Step from './components/Step'
import Rules from './components/Rules'

export interface IStep {
  image?: string
  title: string
  subtitle: string
}
interface IProps {
  title: string
  subtitle: string
  rulesContent?: string[]
  close: () => void
  steps: IStep[]
  dynamic?: string
}

const OnboardingStep: React.FC<IProps> = ({ title, subtitle, rulesContent, close, steps }) => {
  useMainClass('onboarding-steps')

  const [areRulesVisible, setAreRulesVisible] = useState(false)
  const [currentSlide, setCurrentSlide] = useState(0)
  const sliderRef = useRef<Slider>(null)
  const { setActiveActivity } = useActivity()

  useEffect(() => {
    setActiveActivity({
      name: 'onboarding',
      showCloseButton: true,
      exitActivity: () => close()
    })

    return () => {
      setActiveActivity(null)
    }
  }, [])

  const sliderConfig = useMemo(
    () => ({
      arrows: false,
      afterChange: (index: number) => setCurrentSlide(index),
      infinite: false
    }),
    []
  )

  const toggleRulesVisibility = useCallback(() => {
    setAreRulesVisible((prev) => !prev)
  }, [])

  const handlePrevSlide = useCallback(() => {
    sliderRef.current?.slickPrev()
  }, [])

  const handleNextSlide = useCallback(() => {
    sliderRef.current?.slickNext()
  }, [])

  return (
    <>
      {areRulesVisible && (
        <DynamicPopup isOpen={areRulesVisible} onClose={toggleRulesVisibility}>
          <Rules title="Reglas de participación" content={rulesContent} />
        </DynamicPopup>
      )}
      <div className={`onboarding-steps__main onboarding-steps__main-${currentSlide}`}>
        <div className="onboarding-steps__main__container">
          <div className="onboarding-steps__main__container__texts">
            <h2 className="title">{title}</h2>
            <p className="subtitle">{subtitle}</p>
          </div>

          <div className="onboarding-steps__main__container__slider">
            <Slider ref={sliderRef} {...sliderConfig}>
              {steps.map((step, index) => (
                <Step {...step} key={index} />
              ))}
            </Slider>

            <div className="dots">
              <div className="dots__container">
                <button className={currentSlide === 0 ? 'invisible' : ''} onClick={handlePrevSlide}>
                  <img src={`${AZURE_BASE_URL}/arrow-onboarding-step.webp`} alt="arrow" className="arrow-left" />
                </button>
                <DotsIndicator total={steps.length} currentIndex={currentSlide} />
                <button className={currentSlide === steps.length - 1 ? 'invisible' : ''} onClick={handleNextSlide}>
                  <img src={`${AZURE_BASE_URL}/arrow-onboarding-step.webp`} alt="arrow" className="arrow-right" />
                </button>
              </div>
            </div>
          </div>

          <div className="onboarding-steps__main__container__buttons">
            <button onClick={close} className={`button ${currentSlide === steps.length - 1 ? 'start' : 'skip'}`}>
              {currentSlide === steps.length - 1 ? 'Comenzar' : 'Omitir instrucciones'}
            </button>

            {rulesContent && (
              <button className="rules-button" onClick={toggleRulesVisibility}>
                VER LAS REGLAS
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default OnboardingStep
